import { render } from "./WhatToTip.vue?vue&type=template&id=34004eef"
import script from "./WhatToTip.vue?vue&type=script&lang=js"
export * from "./WhatToTip.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__